module.exports = __webpack_public_path__ + "components/home-header/static/header-4--huge@2x-62c7de70fa3e439964e589a34be9a3a4.jpg";